
if (!customElements.get('bundle-products')) {
    customElements.define('bundle-products', class bundleProducts extends HTMLElement {
      constructor() {
        super();
     
        this.buncledsProductAray = [];
        this.bundleId = new Date().getTime();
      }
  
      connectedCallback() {
        this.querySelector('.btn-bundle-submit').addEventListener('click', this.onSubmitHandler2.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-drawer');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.chnageInputProduct();
      }
  
      chnageInputProduct() {
      
        const self = this;
        this.querySelectorAll('input[name="bundleproduct"]').forEach(item => {
          
          if (item.dataset.selling_plan) {
          
            self.buncledsProductAray.push({
              'id': item.value,
              'quantity': 1,
              'selling_plan': item.dataset.selling_plan,
              'properties': {
                '_bundleId': self.bundleId
              }
            });
          }
    
          item.addEventListener('change', function () {
            if (item.checked) {
              self.buncledsProductAray.push({
                'id': item.value,
                'quantity': 1,
                'selling_plan': item.dataset.selling_plan,
                'properties': {
                  '_bundleId': self.bundleId
                }
              });
            } else {
              const indexToRemove = self.buncledsProductAray.findIndex(obj => obj.id === item.value);
              if (indexToRemove !== -1) {
                self.buncledsProductAray.splice(indexToRemove, 1);
              }
            }
          });
        });
      }
  
     async onSubmitHandler2(evt) {
  evt.preventDefault();

  const self = this;

  if (self.buncledsProductAray.length === 0) return;

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  try {
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();

    const updates = {};
    const itemsToAdd = [];

    self.buncledsProductAray.forEach(bundleItem => {
      const matchingCartItem = cart.items.find(cartItem => {
        const cartSellingPlanId =
          cartItem.selling_plan_allocation &&
          cartItem.selling_plan_allocation.selling_plan
            ? String(cartItem.selling_plan_allocation.selling_plan.id)
            : '';

        return (
          Number(cartItem.variant_id) === Number(bundleItem.id) &&
          cartSellingPlanId === String(bundleItem.selling_plan || '')
        );
      });

      if (matchingCartItem) {
        updates[matchingCartItem.key] =
          matchingCartItem.quantity + Number(bundleItem.quantity || 1);
      } else {
        const itemToAdd = {
          id: Number(bundleItem.id),
          quantity: Number(bundleItem.quantity || 1)
        };

        if (bundleItem.selling_plan) {
          itemToAdd.selling_plan = Number(bundleItem.selling_plan);
        }

        itemToAdd.properties = {
          _bundleId: self.bundleId
        };

        itemsToAdd.push(itemToAdd);
      }
    });

    if (Object.keys(updates).length > 0) {
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
    }

    let response = null;

    if (itemsToAdd.length > 0) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      const body = {
        items: itemsToAdd
      };

      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map(section => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = JSON.stringify(body);

      const addResponse = await fetch(`${routes.cart_add_url}`, config);
      response = await addResponse.json();

      if (response.status) {
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
        }

        this.error = true;
        return;
      }
    }

    this.error = false;
if (this.cart) {
  if (response) {
    this.cart.renderContents(response);
  } else {
  const refreshResponse = await fetch(
  window.location.pathname +
    '?sections=' +
    this.cart.getSectionsToRender().map(section => section.id).join(',')
);

    const sections = await refreshResponse.json();

    this.cart.renderContents({
      sections: sections
    });
  }

  setTimeout(() => {
    if (typeof getDataCart === 'function') {
      getDataCart();
    }

    if (typeof openProtectionPopupInDrawerCart === 'function') {
      openProtectionPopupInDrawerCart();
    }

    if (typeof promocodeSlideToggle === 'function') {
      promocodeSlideToggle();
    }

    if (typeof checkDoscuntLabelInAppTotalsDrawers === 'function') {
      checkDoscuntLabelInAppTotalsDrawers();
    }
  }, 300);
}

    if (typeof cartItemCount === 'function') {
      cartItemCount();
    }

  } catch (e) {
    console.error(e);
  } finally {
    this.submitButton.classList.remove('loading');

    if (this.cart && this.cart.classList.contains('is-empty')) {
      this.cart.classList.remove('is-empty');
    }

    if (!this.error) {
      this.submitButton.removeAttribute('aria-disabled');
    }
  }
}
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }